import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/site';
const { FiArrowRight } = FiIcons;
function CTABanner() {
  return (
    <section className="cta-banner">
      <div className="cta-banner-bg">
        <img src="https://images.unsplash.com/photo-1600566753376-12c8ab7f759c?auto=format&fit=crop&w=2000&q=85" alt="" />
      </div>
      <motion.div className="cta-banner-inner" initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}>
        <span className="eyebrow center light">Ready when you are</span>
        <h2>Let's find a place<br />worth <em>coming home to.</em></h2>
        <p>One conversation can change the way you think about your next move. We'd love to be part of yours.</p>
        <a className="btn btn-sand" href={waLink('Hello Havenfield, I would like to start a conversation about my property plans.')} target="_blank" rel="noopener noreferrer">
          Start the conversation <SafeIcon icon={FiArrowRight} />
        </a>
      </motion.div>
    </section>
  );
}
export default CTABanner;
